import { render, staticRenderFns } from "./LanguageChoice.vue?vue&type=template&id=2926bcd4&"
import script from "./LanguageChoice.vue?vue&type=script&lang=js&"
export * from "./LanguageChoice.vue?vue&type=script&lang=js&"
import style0 from "./LanguageChoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports